import type { FrontendWidget } from '../types';
import { SealsComponent } from './SealsComponent';
import { SealsComponentB } from './SealsComponentB';
import { SealsComponentC } from './SealsComponentC';
import type { SealsWidgetConfig, SealsWidgetResolved } from './types';

export const sealsWidget: FrontendWidget<
  SealsWidgetConfig,
  SealsWidgetResolved
> = {
  componentType: 'widgets.seals-widget',
  displayName: 'Seals Widget',
  ComponentA: SealsComponent,
  ComponentB: SealsComponentB,
  ComponentC: SealsComponentC,
  // No resolveSync — lookup widget. Resolved data arrives from
  // POST /api/resolve-widgets.
};
